import { routes } from 'commons';
import { Anchor, Header, Loading, Main } from 'components';
import { useAuth } from 'hooks';
import { StoreDetailsStore } from 'zustand-store';
import { OpeningDays } from './components';

export function OpeningDaysPage() {
  const { storeDetails, isLoading } = StoreDetailsStore.useGetStoreDetails({
    fullHistory: true,
    revalidate: true,
  });

  const { openingDays } = storeDetails || {};

  const { selectedStore } = useAuth();
  const { name: store } = selectedStore;

  if (isLoading) {
    return (
      <Main>
        <Header />

        <div className="flex flex-col overflow-y-scroll h-full pt-5 pb-14 px-7 md:px-12">
          <Loading />
        </div>
      </Main>
    );
  }

  return (
    <Main>
      <Header />

      <div
        className="flex flex-col items-start gap-6 overflow-y-scroll h-full pt-5 pb-14 px-7
          md:px-12"
      >
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-bold">Horário da loja</h1>

          <p className="max-w-[748px] text-base">
            <span>
              Defina os dias e horários em que sua loja estará disponível para
              atendimento e entregas.
            </span>
            <br />
            <span>
              Esses horários serão exibidos para o cliente e usados para
              organizar a coleta.
            </span>
          </p>

          <p className="max-w-[748px] text-base">
            <span className="font-bold">Importante: </span>
            <span>Todos os horários devem ser configurados no </span>
            <span className="font-bold">fuso horário de Brasília (UTC-3)</span>
            <span>, mesmo que sua loja esteja em outro estado.</span>
          </p>
        </div>

        <OpeningDays key={store} openingDays={openingDays} />

        <div className="flex flex-col gap-2">
          <h3 className="text-base font-bold">Outras configurações</h3>
          <p className="text-xs">
            Tenha acesso direto as páginas de outras configurações:
          </p>

          <div className="flex gap-x-7 gap-y-1 sm:flex-row flex-col">
            <Anchor to={routes.profile.path}>Perfil da loja</Anchor>

            <Anchor to={routes.discount.path}>Descontos</Anchor>
          </div>
        </div>
      </div>
    </Main>
  );
}
